export default __webpack_public_path__ + "static/media/24.7g1881ob.360ca59e.jpeg";